module.exports = __webpack_public_path__ + "media/images/a-l-origine-017f22a1183c26970e5376d6ba24069a.jpg";